import * as swcHelpers from '@swc/helpers';

const options = {
    width: 'w',
    height: 'h',
    backgroundColor: 'bg',
    fit: 'fit',
    format: 'fm',
    quality: 'q'
};
/**
 * ImgIX transforms animated gifs into static gifs when processing them, so we have to exclude it from ImgIX processing.
 */ const shouldSkipImageProcessing = (url)=>url.toLowerCase().endsWith('.gif')
;
var createImageUrl = (url, params = {})=>{
    if (shouldSkipImageProcessing(url)) {
        return url;
    }
    const { aspectRatio  } = params, cleanParams = swcHelpers.objectWithoutProperties(params, [
        "aspectRatio"
    ]);
    if (cleanParams.height === undefined && aspectRatio && cleanParams.width) {
        // Calculate height based on the aspectRatio
        cleanParams.height = Math.round(cleanParams.width / aspectRatio);
    }
    // Reduce quality for very large widths (https://docs.imgix.com/tutorials/responsive-images-srcset-imgix#use-variable-quality)
    if (cleanParams.width && cleanParams.width > 1920 && (!cleanParams.quality || cleanParams.quality > 50)) {
        cleanParams.quality = 50;
    }
    const urlParams = Object.entries(cleanParams).map(([key, value])=>{
        return `${options[key]}=${value}`;
    });
    return `${url}?${urlParams.join('&')}&auto=format`;
};

export { createImageUrl, shouldSkipImageProcessing };
//# sourceMappingURL=create-image-url.js.map
